import api from "./client";

export const importScadaCsv = async (siteId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post(`/scada/import/csv?site_id=${siteId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

const buildFormData = ({ siteId, file, startDate, endDate, userName, overwriteDuplicates }) => {
  const form = new FormData();
  form.append("site_id", siteId);
  if (file) form.append("file", file);
  if (startDate) form.append("start_date", startDate);
  if (endDate) form.append("end_date", endDate);
  if (userName) form.append("user_name", userName);
  if (typeof overwriteDuplicates !== "undefined") {
    form.append("overwrite_duplicates", overwriteDuplicates ? "true" : "false");
  }
  return form;
};

export const preflightScadaImport = async ({ siteId, file, startDate, endDate }) => {
  const formData = buildFormData({ siteId, file, startDate, endDate });
  const { data } = await api.post("/scada/import/preflight", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const commitScadaImport = async ({ siteId, file, startDate, endDate, userName, overwriteDuplicates }) => {
  const formData = buildFormData({ siteId, file, startDate, endDate, userName, overwriteDuplicates });
  const { data } = await api.post("/scada/import/commit", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

// Import jobs (ZIP with progress)
export const startImportJob = async ({ siteId, file, startDate, endDate, overwriteDuplicates }) => {
  const formData = buildFormData({ siteId, file, startDate, endDate, overwriteDuplicates });
  const { data } = await api.post("/scada/import/job/start", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const fetchImportJobStatus = async (jobId) => {
  const { data } = await api.get(`/scada/import/job/status/${jobId}`);
  return data;
};

export const cancelImportJob = async (jobId) => {
  const { data } = await api.post(`/scada/import/job/cancel/${jobId}`);
  return data;
};

export const listImportBatches = async ({ siteId, from, to } = {}) => {
  const params = new URLSearchParams();
  if (siteId) params.append("site_id", siteId);
  if (from) params.append("from", from);
  if (to) params.append("to", to);
  const query = params.toString() ? `?${params.toString()}` : "";
  const { data } = await api.get(`/scada/import/batches${query}`);
  return data;
};

export const listImportFiles = async (batchId) => {
  const { data } = await api.get(`/scada/import/batch/${batchId}/files`);
  return data;
};

export const revokeImportBatch = async (batchId) => {
  const { data } = await api.post(`/scada/import/batch/${batchId}/revoke`);
  return data;
};

export const revokeImportFile = async (fileId) => {
  const { data } = await api.post(`/scada/import/file/${fileId}/revoke`);
  return data;
};

export const getScadaData = async ({ siteId, start, end, inverterLinkId, signalMatchId }) => {
  const params = new URLSearchParams();
  if (start) params.append("start", start);
  if (end) params.append("end", end);
  if (inverterLinkId) params.append("inverter_link_id", inverterLinkId);
  if (signalMatchId) params.append("signal_match_id", signalMatchId);
  const query = params.toString() ? `?${params.toString()}` : "";
  const { data } = await api.get(`/scada/site/${siteId}${query}`);
  return data;
};
